import { FC } from 'react';
import { useSelector } from 'react-redux';
import { siteListSelector } from '../SiteList/selectors';

import Map from './Map';
import SectionStyled from './styles';

type MapSiteProps = {};

const MapSites: FC<MapSiteProps> = () => {
  const { map } = useSelector(siteListSelector);

  const lng = map && map.sites && map.sites.find((value) => value.site_lng);
  const lat = map && map.sites && map.sites.find((value) => value.site_lat);

  return (
    <SectionStyled>
      {map ? (
        <Map
          defaultZoom={10} // 10km
          defaultCenter={{
            lat:
              map.average_site_lat && map.average_site_lat !== 0
                ? map.average_site_lat
                : lat?.site_lat,
            lng:
              map.average_site_lng && map.average_site_lng !== 0
                ? map.average_site_lng
                : lng?.site_lng,
          }}
          listMarket={map.sites}
        />
      ) : (
        <div style={{ position: 'relative', height: 'calc(100vh - 106px)', width: '100%' }}>
          <div
            aria-label="Loading"
            style={{
              position: 'absolute',
              inset: 0,
              display: 'grid',
              placeItems: 'center',
              background: '#fff',
              zIndex: 10,
            }}
          >
            <div style={{ display: 'grid', placeItems: 'center', gap: 10 }}>
              <svg width="52" height="52" viewBox="0 0 50 50" aria-hidden="true">
                <circle
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke="rgba(0,0,0,.12)"
                  strokeWidth="4"
                />
                <path
                  d="M25 5 a20 20 0 0 1 0 40"
                  fill="none"
                  stroke="#1C4B8C"
                  strokeWidth="4"
                  strokeLinecap="round"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="0.8s"
                    repeatCount="indefinite"
                  />
                </path>
              </svg>
              <div
                style={{ fontSize: 13, color: '#333', whiteSpace: 'pre-line', textAlign: 'center' }}
              >
                {`現場の位置特定中...  \nしばらくお待ちください。  \n※取得に時間がかかる場合は、物件情報のデータが存在しない可能性があります。`}
              </div>
            </div>
          </div>
        </div>
      )}
    </SectionStyled>
  );
};

export default MapSites;
